import moment from "moment";
import "moment/locale/es"

export function getDateObject(dateString, locale = "en") {

  moment.locale(locale);
  const date = moment(dateString);

  return {
    weekday: date.format("dddd"),
    day: date.format("DD"),
    month: date.format("MMMM"),
    year: date.format("Y")
  }
}